import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ACTIONS, KEYS, STORAGE } from '../../_config';

export const useAuthSync = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      // If auth tokens are removed from localStorage (logout in another tab)
      if (e.key === KEYS.AUTH_ACCESS && e.newValue === null) {
        dispatch({
          type: ACTIONS.USER.LOGOUT,
          payload: {}
        });
      }
      
      // If user data is added to localStorage (login in another tab)
      if (e.key === STORAGE && e.newValue && !e.oldValue) {
        try {
          const userData = JSON.parse(e.newValue);
          const accessToken = localStorage.getItem(KEYS.AUTH_ACCESS);
          const refreshToken = localStorage.getItem(KEYS.AUTH_REFRESH);
          
          if (userData && accessToken && refreshToken) {
            dispatch({
              type: ACTIONS.USER.LOGIN,
              payload: {
                user: userData,
                accessToken: accessToken,
                refreshToken: refreshToken,
                isAuthenticated: true,
                permissions: true
              }
            });
          }
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error);
        }
      }
    };

    // Listen for localStorage changes
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);
};